import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import {
  FDBox,
  FDListItem, FDListItemText, FDListItemTextRightAligned,
} from '@facet-wealth/design';

const ScenarioSelectionAssumptionSectionLineItem = ({ resource }) => {
  return (
    <FDBox paddingY={2}>
      <FDListItem key={resource.id()}>
        <FDListItemText primaryText={resource.attr('title')} />
        <FDListItemTextRightAligned primaryText={resource.attr('value')} />
      </FDListItem>
    </FDBox>
  );
};

ScenarioSelectionAssumptionSectionLineItem.defaultProps = {};

ScenarioSelectionAssumptionSectionLineItem.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionAssumptionSectionLineItem;
